(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lopeta-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lopeta-choice')) {
  customElements.define('lopeta-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-lopeta-choice]');
        if (!button || !this.contains(button)) return;
        const selected = button.dataset.lopetaChoice;
        this.querySelectorAll('[data-lopeta-choice]').forEach((item) => {
          const active = item.dataset.lopetaChoice === selected;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        this.querySelectorAll('[data-lopeta-panel]').forEach((panel) => {
          const active = panel.dataset.lopetaPanel === selected;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
